'use es6';

import { createSelector } from 'reselect';
import { debugGate } from '../utils/env'; // eslint-disable-line

const getPortal = state => state.auth.portal;

const getPortalScopes = state => state.auth.portal.scopes;

const getUserScopes = state => state.auth.user.scopes;

const getUser = state => state.auth.user;

const getGates = state => state.auth.gates;

export const getAuth = state => state.auth;
const getIsUngated = createSelector([getGates], gates => gate => gates.includes(gate) || debugGate(gate));
export const getHasMarketplaceAssetAccess = createSelector([getUserScopes], scopes => scopes.includes('marketplace-asset-access'));
export const makeGetMissingPortalScopes = () => createSelector([getPortalScopes, (__state, scopes) => scopes], (portalScopes, scopes) => scopes.filter(scope => !portalScopes.includes(scope)));
export const getIsCustomer = createSelector([getPortal], portal => !!(portal && portal.portal_id));
export const getUserFirstName = createSelector([getUser], user => user.first_name);
export const getUserLastName = createSelector([getUser], user => user.last_name);
export const getUserEmail = createSelector([getUser], user => user.email);
export const getUserId = createSelector([getUser], user => user.user_id);
export const getHasRequiredSubscription = createSelector([getPortalScopes], portalScopes => portalScopes.includes('global-content-write-access'));
export const getHasZorseWebticketScope = createSelector([getUserScopes], scopes => scopes.includes('zorse-webticket'));
export const getIsUngatedForDisablePaypal = createSelector([getIsUngated], isUngated => isUngated('Marketplace:Assets:disable-paypal'));
export const getIsUngatedForPurchaseScopedFeatures = createSelector([getIsUngated], isUngated => isUngated('Marketplace:Assets:purchase-scoped-features'));
export const getIsUngatedForContentTypes = createSelector([getIsUngated], isUngated => isUngated('CMv2:UseContentTypes'));